const ZERO = { runs: 0, wickets: 0, deliveries: 0, ballValues: [] };

// Reference scoreboardData (spnnation1/2, score1/2, spnrunrate1/2, spnreqrate1/2, spnmessage, balls)
function toScoreboard(sc, gmid, isFiveOver) {
  const overBalls = Number(sc?.overBalls) || 6;
  const inningsBalls = Number(sc?.inningsBalls) || overBalls;
  const maxWickets = Number(sc?.maxWickets) || (isFiveOver ? 10 : 2);
  const live = sc && sc.scoreByTeam && String(sc.gmid) === String(gmid);
  const team1 = (live && (sc.firstTeam || sc.team1)) || sc?.team1 || "";
  const team2 = live ? (team1 === sc.team1 ? sc.team2 : sc.team1) || "" : sc?.team2 || "";
  const s1 = (live && sc.scoreByTeam[team1]) || ZERO;
  const s2 = (live && sc.scoreByTeam[team2]) || ZERO;
  const overs = (d) => `${Math.floor(d / overBalls)}.${d % overBalls}`;
  const fmt = (s) => `${s.runs}-${s.wickets} (${overs(s.deliveries)})`;
  const rate = (s) => (s.deliveries > 0 ? ((s.runs / s.deliveries) * overBalls).toFixed(2) : "0.00");

  const chase = live && Number(sc.phase) === 2;
  const bat = chase ? s2 : s1;
  const out = {
    spnnation1: team1,
    spnnation2: team2,
    score1: fmt(s1),
    score2: fmt(s2),
    spnrunrate1: chase ? "" : rate(s1),
    spnreqrate1: "",
    spnrunrate2: chase ? rate(s2) : "",
    spnreqrate2: "",
    spnmessage: "",
  };
  if (chase) {
    const ballsLeft = inningsBalls - s2.deliveries;
    const need = s1.runs + 1 - s2.runs;
    const ended = need <= 0 || ballsLeft <= 0 || s2.wickets >= maxWickets;
    if (ended) {
      out.spnmessage = need <= 0 ? `${team2} won the match` : need === 1 ? "Match Tied" : `${team1} won the match`;
    } else {
      out.spnmessage = `${team2} Needed ${need} runs from ${ballsLeft} balls`;
      out.spnreqrate2 = ((need / ballsLeft) * overBalls).toFixed(2);
    }
  }
  // Last over's balls (5Five Cricket shows wickets as "ww", like the reference)
  const vals = (bat.ballValues || []).slice(-6).map((v) => (isFiveOver && v === "W" ? "ww" : v));
  out.balls = vals;
  return out;
}

/**
 * Reference .banner scorecard of casino/superover and casino/cricketv3 (shown while scard == 1).
 */
export default function FiveCricketScorecard({ scorecard, gmid, scard, isFiveOver }) {
  if (Number(scard) !== 1 || !scorecard) return null;
  const s = toScoreboard(scorecard, gmid, isFiveOver);
  const rates = (crr, rr, nl) => (
    <span className="team-name">
      {crr !== "" ? <span>{` CRR ${crr}${nl} `}</span> : null} {rr !== "" ? <span>{` RR ${rr} `}</span> : null}
      {"  "}
    </span>
  );
  return (
    <div className="scorecard m-b-5">
      <div className="row">
        <div className="col-md-5">
          <p className="team-1 row mb-0">
            <span className="team-name col-md-3">{s.spnnation1}</span>{" "}
            <span className="score col-md-9 text-right">{s.score1}</span>
          </p>{" "}
          <p className="team-1 row mb-0">
            <span className="team-name col-md-3">{s.spnnation2}</span>{" "}
            <span className="score col-md-9 text-right">{s.score2}</span>
          </p>
        </div>{" "}
        <div className="col-md-7">
          <div className="row">
            <div className="col-md-5">
              <div className="row">{rates(s.spnrunrate1, s.spnreqrate1, " ")}</div>{" "}
              <div className="row m-t-10">{rates(s.spnrunrate2, s.spnreqrate2, "")}</div>
            </div>{" "}
            <div className="col-md-7">
              <div className="text-right">
                <p className="mb-0">{` ${s.spnmessage} `}</p>
              </div>{" "}
              <div className="row">
                <div className="col-md-12">
                  <p className="text-right ball-by-ball mb-0">
                    {s.balls.map((b, i) =>
                      b !== "" ? (
                        <span
                          key={i}
                          className={`ball-runs mr-1${b === "4" ? " four" : ""}${b === "6" ? " six" : ""}${
                            b.toLowerCase() === "ww" ? " wicket" : ""
                          }`}
                        >
                          {` ${b} `}
                        </span>
                      ) : null,
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
